import { Button, Icon } from "@growtherapy/sprout-ui";
import { twMerge } from "tailwind-merge";

import { ActionType, ActionStateToggleButtonProps } from "./types";
import {
  MUSIC_ACTION_ICONS,
  useBackgroundMusicPlayback,
} from "./useBackgroundMusicPlayback";

export function MusicStateToggleButton({
  className,
  currentActionState,
  isToneLoading,
  onClick,
}: {
  className?: string;
  currentActionState: ActionType;
  isToneLoading: boolean;
  onClick: () => void;
}): JSX.Element {
  const nextActionIcon = MUSIC_ACTION_ICONS[currentActionState];

  const label =
    currentActionState === ActionType.PLAY ? "Music on" : "Music off";

  return (
    <Button
      use="link"
      size="sm"
      loading={isToneLoading}
      className={twMerge(
        "flex gap-x-2 items-center text-yellow-700 no-underline hover:brightness-75 hover:text-yellow-700",
        className,
      )}
      onClick={() => onClick()}
      aria-label={label}
    >
      <Icon icon={nextActionIcon} />
      {label}
    </Button>
  );
}

export type ActionStateToggleButtonWrapperProps = Pick<
  ActionStateToggleButtonProps,
  "className"
>;

export function MusicStateToggleButtonWrapper(
  props: ActionStateToggleButtonWrapperProps,
) {
  const { currentMusicState, toggleMusic, isToneLoading } =
    useBackgroundMusicPlayback();
  return (
    <MusicStateToggleButton
      {...props}
      currentActionState={currentMusicState}
      onClick={toggleMusic}
      isToneLoading={isToneLoading}
    />
  );
}
